export default "__VITE_ASSET__hj7cWQWj__"